import { Stroke, Style } from "ol/style";
import { extractTags } from "./propertyExtraction";
import { shiftLeft, shiftRight } from "./util/offsetLineString";

export function getHDLaneBorderStyleNormal(feature, resolution) {
  return getHDLaneBorderColorStyle(feature, false, false, resolution);
}
export function getHDLaneBorderStyleClick(feature, resolution) {
  return getHDLaneBorderColorStyle(feature, true, false, resolution);
}
export function getHDLaneBorderStyleHover(feature, resolution) {
  return getHDLaneBorderColorStyle(feature, false, true, resolution);
}
function getHDLaneBorderColorStyle(feature, click, hover, resolution) {
  const tags = extractTags(feature);
  let hdmapType = tags.hdMap;

  if (hdmapType !== undefined) {
    if (hdmapType !== "lane_border") {
      return;
    }
  }

  let type = feature.get("type");
  if (type === "ORBIS_RELATION") {
    return;
  }

  let laneBorder = tags.laneBorder;
  let backgroundWidth = 6;
  if (hover || click) {
    backgroundWidth = 10;
  }
  if (laneBorder === undefined) {
    return [
      new Style({
        stroke: new Stroke({
          color: "lightgrey",
          width: 1,
          lineCap: "butt",
        }),
      }),
    ];
  }
  if (laneBorder.includes("double_solid")) {
    return [
      new Style({
        stroke: new Stroke({
          color: "grey",
          width: backgroundWidth,
          lineCap: "butt",
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: "yellow",
          width: 3,
          lineCap: "butt",
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: "grey",
          width: 1,
          lineCap: "butt",
        }),
      }),
    ];
  }

  if (laneBorder.includes("solid_dashed")) {
    return [
      new Style({
        stroke: new Stroke({
          color: "grey",
          width: backgroundWidth + 4,
          lineCap: "butt",
        }),
      }),
      // left
      new Style({
        geometry: shiftLeft(feature, resolution, 2),
        stroke: longDashStroke,
        lineCap: "butt",
      }),
      // right
      new Style({
        geometry: shiftRight(feature, resolution, 2),
        stroke: whiteLineStroke,
        lineCap: "butt",
      }),
    ];
  }

  if (laneBorder.includes("dashed_solid")) {
    return [
      new Style({
        stroke: new Stroke({
          color: "grey",
          width: backgroundWidth + 4,
          lineCap: "butt",
        }),
      }),
      // left
      new Style({
        geometry: shiftLeft(feature, resolution, 2),
        stroke: whiteLineStroke,
        lineCap: "butt",
      }),
      // right
      new Style({
        geometry: shiftRight(feature, resolution, 2),
        stroke: longDashStroke,
        lineCap: "butt",
      }),
    ];
  }

  if (laneBorder.includes("solid")) {
    return [
      new Style({
        stroke: new Stroke({
          color: "grey",
          width: backgroundWidth,
          lineCap: "butt",
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: "white",
          width: 2,
          lineCap: "butt",
        }),
      }),
    ];
  }
  if (laneBorder.includes("dashed")) {
    return [
      new Style({
        stroke: new Stroke({
          color: "grey",
          width: backgroundWidth,
          lineCap: "butt",
        }),
      }),
      new Style({
        stroke: shortDashedStroke,
      }),
    ];
  }
  if (laneBorder.includes("road_border")) {
    return [
      new Style({
        stroke: new Stroke({
          color: "grey",
          width: backgroundWidth - 2,
          lineCap: "butt",
        }),
      }),
    ];
  }
  if (laneBorder.includes("virtual")) {
    return [
      new Style({
        stroke: new Stroke({
          color: "lightgrey",
          width: 2,
          lineCap: "butt",
        }),
      }),
    ];
  }
}

const longDashStroke = new Stroke({
  color: "white",
  lineDash: [10, 25],
  width: 2,
  lineCap: "butt",
});
const whiteLineStroke = new Stroke({
  color: "white",
  width: 2,
  lineCap: "butt",
});

const shortDashedStroke = new Stroke({
  color: "white",
  lineDash: [10, 5],
  width: 2,
  lineCap: "butt",
});
